import { IconCloseRegular, LogoFastship, LogoStorezigzin, LogoZdelivery } from '@croquiscom-pvt/zds';

import { Typography } from '@common/styles';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { Counter } from '../Counter';
import {
  Badge,
  BogoBadge,
  BottomLine,
  Container,
  DeliveryDate,
  ItemTitle,
  MinimumCount,
  OptionName,
  PreSoldOutText,
  ProductInfo,
  ProductName,
  Tag,
  TotalPrice,
  TouchArea,
  Wrap,
} from './styles';

interface Props {
  hiddenCounter?: boolean;
  disableCounter?: boolean;
  disableMinCounter?: boolean;
  disabledPrice?: boolean;
  minCount?: number;
  maxCount?: number;
  count: number;
  price: number;
  remain_stock?: number | null;
  productName?: string;
  optionNames: string;
  expectedDeliveryDate?: string | null;
  over_max_message?: string;
  under_min_message?: string;
  bogoImageUrl?: string;
  is_store_zigzin?: boolean;
  is_zigzin?: boolean;
  is_additional?: boolean;
  isFastShipping?: boolean;
  isOrderQuantityItemType: boolean;
  onChangeItemCount?: (v: number) => void;
  onRemove?: () => void;
}

export const ItemCard = ({
  hiddenCounter,
  disabledPrice,
  disableCounter = false,
  disableMinCounter = false,
  minCount = 1,
  maxCount,
  count,
  price,
  remain_stock,
  productName,
  optionNames,
  expectedDeliveryDate,
  over_max_message,
  under_min_message,
  bogoImageUrl,
  is_zigzin,
  is_store_zigzin = false,
  isFastShipping = false,
  is_additional,
  isOrderQuantityItemType,
  onChangeItemCount = () => undefined,
  onRemove,
}: Props) => {
  const displayMinOrderText = isOrderQuantityItemType && minCount > 1;
  const displayProductInfo = Boolean(displayMinOrderText || remain_stock);

  return (
    <Container>
      <ItemTitle>
        {bogoImageUrl && <BogoBadge src={bogoImageUrl} alt='bogo image' />}
        {!!productName && <ProductName className={Typography.BODY_14_REGULAR}>{productName}</ProductName>}
        <OptionName className={Typography.BODY_14_MEDIUM}>
          {!!is_additional && `[추가상품] `}
          {optionNames}
        </OptionName>
      </ItemTitle>
      <Tag>
        {is_store_zigzin && is_zigzin && (
          <Badge>
            <LogoStorezigzin width={67} height={11} />
          </Badge>
        )}
        {!is_store_zigzin && is_zigzin && (
          <Badge>
            <LogoZdelivery width={57} height={11} />
          </Badge>
        )}
        {isFastShipping && (
          <Badge>
            <LogoFastship width={62} height={11} />
          </Badge>
        )}
        {expectedDeliveryDate && (
          <DeliveryDate
            isZigzin={is_zigzin}
            is_store_zigzin={is_store_zigzin}
            isFastShipping={isFastShipping}
            dangerouslySetInnerHTML={{ __html: expectedDeliveryDate }}
          />
        )}
      </Tag>
      {!!onRemove && (
        <TouchArea onClick={onRemove}>
          <IconCloseRegular size={20} color='textSecondary' />
        </TouchArea>
      )}
      <BottomLine visible={!hiddenCounter || !disabledPrice || displayProductInfo}>
        {!hiddenCounter && (
          <Counter
            count={count}
            min_count={minCount}
            max_count={maxCount}
            changeEvent={onChangeItemCount}
            disabled={disableCounter}
            minDisabled={disableMinCounter}
            over_max_message={over_max_message}
            under_min_message={under_min_message}
          />
        )}
        <Wrap style={{ top: displayProductInfo ? '-1px' : 0 }}>
          {!disabledPrice && <TotalPrice price={price * count} className={Typography.BODY_15_SEMIBOLD} />}
          {displayProductInfo && (
            <ProductInfo>
              {remain_stock && <PreSoldOutText>{remain_stock}개 남음</PreSoldOutText>}
              {displayMinOrderText && (
                <MinimumCount>
                  (최소 구매수량 : {minCount}개)
                </MinimumCount>
              )}
            </ProductInfo>
          )}
        </Wrap>
      </BottomLine>
    </Container>
  );
};
